import { TypeDefinition } from "../models/generic";

export interface ContentBlockTypeItem extends TypeDefinition {
    type: string;
}

export class ContentBlockTypes {
    public static Text: ContentBlockTypeItem = { id: 1, name: "Text", type: "Webitects.Core.Models.ContentText" };
    public static Carousel: ContentBlockTypeItem = { id: 2, name: "Carousel", type: "Webitects.Core.Models.ContentCarousel" };
    public static Hero: ContentBlockTypeItem = { id: 3, name: "Hero", type: "Webitects.Core.Models.ContentHero" };
    public static LinkList: ContentBlockTypeItem = { id: 4, name: "Link list", type: "Webitects.Core.Models.ContentLinkList" };

    public static Values: ContentBlockTypeItem[] = [
        ContentBlockTypes.Text,
        ContentBlockTypes.Carousel,
        ContentBlockTypes.Hero,
        ContentBlockTypes.LinkList,
    ];
}



// WEBPACK FOOTER //
// ./src/domain/ContentBlockTypes.ts